import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			children: [/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				width: 24,
				height: 24,
				transform: "translate(24 24) rotate(180)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "arrow-head-right",
				className: "cls-2",
				d: "m14.37,12l-6-8h1.26l5.99,8-5.99,8h-1.26l6-8Z"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgRightIcon);
export default ForwardRef;
